import { Controller } from 'stimulus';

export default class extends Controller {
  static classes = ['overflowing'];

  connect() {
    this.update = this.update.bind(this);
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.element);
    this.update();
  }

  disconnect() {
    this.resizeObserver && this.resizeObserver.disconnect();
  }

  update() {
    const overflowing = this.element.scrollHeight > this.element.clientHeight;
    this.element.classList.toggle(this.overflowingClass, overflowing);
  }
}
